import { GameManager } from "../managers/GameManager";

export class Quiz{
    questions:Array<Question>
    fullScorePerQuestion:number;
    timeLimitPerQuestion:number|null;
    practiceMode:boolean;
    currentCorrectAnswers:number = 0;
    currentQuestion:number = 0;
    currentTimeRemaining:number = 0;
    currentScore:number = 0;
    
    constructor(questions:Array<Question>,fullScorePerQuestion:number,practiceMode:boolean,timeLimitPerQuestion:number|null){
        this.questions = questions;
        this.fullScorePerQuestion= fullScorePerQuestion;
        this.practiceMode = practiceMode;
        this.timeLimitPerQuestion = timeLimitPerQuestion;
    }
}
export class VideoLifeQuiz{
    videoQuestions:Array<VideoTimedQuestion>;
    maxLife:number;
    fullScorePerQuestion:number;
    practiceMode:boolean;
    timeLimitPerQuestion:number|null;
    //States
    
    currentCorrectAnswers:number
    currentQuestion:number;
    currentLife:number;
    currentTimeRemaining:number;
    currentScore:number;
    currentGivenAnswer:number;
    constructor(videoQuestions:Array<VideoTimedQuestion>,fullScorePerQuestion:number,maxLife:number,practiceMode:boolean,timeLimitPerQuestion:number|null){
        this.videoQuestions = videoQuestions;
        this.maxLife = maxLife;
        this.fullScorePerQuestion = fullScorePerQuestion;
        this.practiceMode = practiceMode;
        this.timeLimitPerQuestion = timeLimitPerQuestion;
        //Initialization
        this.currentQuestion = 0;
        this.currentCorrectAnswers = 0;
        this.currentScore = 0;
        this.currentLife = this.maxLife;
        this.currentTimeRemaining = this.timeLimitPerQuestion ? this.timeLimitPerQuestion : (videoQuestions ? (videoQuestions.length > 0 ? videoQuestions[0].timeLimit: 100) : 100);
        this.currentGivenAnswer = -1;
    }
}

export class ImageLifeQuiz{
    imageQuestions:Array<ImageTimedQuestion>;
    maxLife:number;
    fullScorePerQuestion:number;
    practiceMode:boolean;
    timeLimitPerQuestion:number|null;
    //States
    
    currentCorrectAnswers:number
    currentQuestion:number;
    currentLife:number;
    currentTimeRemaining:number;
    currentScore:number;
    currentGivenAnswer:number;
    constructor(imageQuestions:Array<ImageTimedQuestion>,fullScorePerQuestion:number,maxLife:number,practiceMode:boolean,timeLimitPerQuestion:number|null){
        this.imageQuestions = imageQuestions;
        this.maxLife = maxLife;
        this.fullScorePerQuestion = fullScorePerQuestion;
        this.practiceMode = practiceMode;
        this.timeLimitPerQuestion = timeLimitPerQuestion;
        //Initialization
        this.currentQuestion = 0;
        this.currentCorrectAnswers = 0;
        this.currentScore = 0;
        this.currentLife = this.maxLife;
        this.currentTimeRemaining = this.timeLimitPerQuestion ? this.timeLimitPerQuestion : (imageQuestions ? (imageQuestions.length > 0 ? imageQuestions[0].timeLimit: 100) : 100);
        this.currentGivenAnswer = -1;
    }
}
export class LetteratiQuiz{
    questions:Array<LetteratiQuestion>;
    maxLife:number;
    fullScorePerQuestion:number;
    practiceMode:boolean;
    timeLimitPerQuestion:number|null;
    timeLimitPerLetter:number|null;
    gameTime:number|null;

    //States
    currentCorrectAnswers:number
    currentQuestion:number;
    currentLife:number;
    currentTimeRemaining:number;
    currentScore:number;
    currentGivenAnswer:number;
    currentLetterChoices:Array<ILetterChoice>;
    currentGivenLetters:string;
    currentGameTime:number;
    currentRound:number;
    isDone:boolean = false;
    constructor(questions:Array<LetteratiQuestion>,fullScorePerQuestion:number,maxLife:number,practiceMode:boolean,timeLimitPerQuestion:number|null,timeLimitPerLetter:number){
        this.questions = questions;
        this.maxLife = maxLife;
        this.fullScorePerQuestion = fullScorePerQuestion;
        this.practiceMode = practiceMode;
        this.timeLimitPerQuestion = timeLimitPerQuestion;
        this.timeLimitPerLetter = timeLimitPerLetter;
        //Initialization
        this.currentQuestion = 0;
        this.currentCorrectAnswers = 0;
        this.currentScore = 0;
        this.currentLife = this.maxLife;
        this.currentTimeRemaining = this.getTimeLimit();
        this.currentGivenAnswer = -1;
        this.currentLetterChoices = [];
        this.currentGivenLetters = '';
        this.currentRound = 1;
        this.gameTime = 180;
        if((<GameManager>GameManager.instance).cbnGameConfig!.customTimeLimit != null)
        {
            this.gameTime = (<GameManager>GameManager.instance).cbnGameConfig!.customTimeLimit;
            this.gameTime = (<number>this.gameTime!)/1000;
        }
        this.currentGameTime = this.gameTime;
    }
    getTimeLimit():number{
        //Get Unique letter count;
        let noDupeAnswer = Array.from(new Set(this.questions[this.currentQuestion].answer.split(''))).join(""); //Remove Duplicate Chars
        noDupeAnswer = noDupeAnswer.replace(/[^a-zA-Z]+/g, ''); //Remove non-letter characters.
        let uniqueLetterCount = noDupeAnswer.length;
        return uniqueLetterCount * this.timeLimitPerLetter!;
    }

    getGameTime():number{
        return this.gameTime!;
    }

}

interface ILetterChoice{
    letter:string;
    correct:boolean;
}

export interface IQuestion{
    id:string;
    question:string;
    answers:Array<string>;
    correctAnswers:Array<number>;
}
export class Question implements IQuestion{
    id:string;
    question:string;
    answers:Array<string>;
    correctAnswers:Array<number>;

    constructor(question:IQuestion){
        this.id = question.id;
        this.question = question.question;
        this.answers = question.answers;
        this.correctAnswers = question.correctAnswers;
    }
}
export class TimedQuestion extends Question{
    timeLimit:number;
    constructor(question:IQuestion,timeLimit:number){
        super(question);
        this.timeLimit = timeLimit;
    }

}
export class VideoTimedQuestion extends TimedQuestion{
    videoSource:any;
    constructor(question:IQuestion,timeLimit:number,videoSource:any){
        super(question,timeLimit);
        this.videoSource = videoSource;
    }
}
export class ImageTimedQuestion extends TimedQuestion{
    questionImageSource:string;
    answerImageSource:string;
    constructor(question:IQuestion,timeLimit:number,questionImageSource:string,answerImageSource:string){
        super(question,timeLimit);
        this.questionImageSource = questionImageSource;
        this.answerImageSource = answerImageSource
    }
}

export class LetteratiQuestion{
    id:string;
    question:string;
    answer:string;
    timeLimit:number;

    constructor(id:string,question:string,answer:string,timeLimit:number){
        this.id = id
        this.question = question;
        this.answer = answer;
        this.timeLimit = timeLimit;
    }
}